<template>
<v-container>
    <v-layout row justify-center>
      <v-dialog v-model="dialogCrop" persistent lazy color="primary">
        <v-card>
          <v-toolbar dark color="#607d8b">
            <v-toolbar-title dark color="white">แก้ไขรูปโปรไฟล์</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="close_dialog()">
              <v-icon color="white">close</v-icon>
            </v-btn>
          </v-toolbar>
              <v-flex class="layoutdialog">
                <vue-avatar
                  ref="vueavatar"
                  :width=320
                  :height=320
                  :rotation="rotation"
                  :scale="scale"
                  :image="pic_pro()"
                  @vue-avatar-editor:image-ready="onImageReady"
                >
                </vue-avatar>
              </v-flex>
              <v-container>
                <p style="color: red;">*กรุณาคลิกที่รูปภาพเพื่อทำการอัพโหลดรูปภาพ</p>
              </v-container>
              <v-flex>
                <v-container>
                  <v-slider
                    v-model="scale"
                    label="Zoom :"
                    min=1
                    max=3
                    step=0.02
                    thumb-label="always"
                    ticks
                  ></v-slider>
                  <v-slider
                    v-model="rotation"
                    label="Rotation :"
                    min=0
                    max=360
                    step=1
                    thumb-label="always"
                    ticks
                  ></v-slider>
                </v-container>
              </v-flex>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                v-if="checkUpdateprofile === false"
                disabled
                outline
                style="margin-right: 0.5em; border: 1px solid #a6a6a6; border-radius: 25px;"
                >
                บันทึก
                </v-btn>
                <v-btn
                v-if="checkUpdateprofile === true"
                color="success"
                outline
                @click="sendImagecrop()"
                style="margin-right: 0.5em; border: 1px solid green; border-radius: 25px;"
                >
                บันทึก
                </v-btn>
                <v-btn
                color="error"
                outline
                @click="close_dialog()"
                style="border: 1px solid red; border-radius: 25px;"
                >
                ปิด
                </v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
</v-container>
</template>
<script>
import { VueAvatar } from 'vue-avatar-editor-improved'
export default {
  props: {
    dialogCrop: Boolean,
    profilepicture: String,
    tokenbot: String
  },
  components: {
    VueAvatar
  },
  data () {
    return {
      img: '',
      crop_img: '',
      activeinfo: 'tab-1',
      scale: 1,
      rotation: 0,
      upload_file: '',
      checkUpdateprofile: false,
      pic_default: 'https://image.flaticon.com/icons/svg/149/149071.svg'
    }
  },
  watch: {
    dialogCrop () {
      if (this.dialogCrop === true) {
        this.activeinfo = 'tab-1'
        this.checkUpdateprofile = false
        // if (this.profilepicture === '') {
        //   this.img = this.pic_default
        //   this.checkUpdateprofile = false
        //   return this.img
        // } else {
        //   this.img = this.profilepicture
        //   console.log(this.img)
        //   this.checkUpdateprofile = false
        //   return this.img
        // }
      }
    }
  },
  methods: {
    pic_pro () {
      if (this.profilepicture === '') {
        this.img = this.pic_default
        // this.checkUpdateprofile = false
        return this.img
      } else {
        this.img = this.profilepicture
        // this.checkUpdateprofile = false
        return this.img
      }
    },
    onImageReady () {
      if (this.$refs.vueavatar.imageChanged()) {
        this.checkUpdateprofile = true
      } else {
        this.checkUpdateprofile = false
      }
      this.scale = 1
      this.rotation = 0
    },
    close_dialog () {
      this.$refs.vueavatar.loadImage(this.img)
      this.$refs.vueavatar.redraw()
      this.scale = 1
      this.rotation = 0
      this.$refs.vueavatar.imageChanged()
      this.checkUpdateprofile = false
      this.$emit('closeEditdialog', false)
    },
    b64toBlob (data) {
      var byteString = atob(data.split(',')[1])
      var ab = new ArrayBuffer(byteString.length)
      var ia = new Uint8Array(ab)
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }
      return new Blob([ab], { type: 'image/jpeg' })
    },
    sendImagecrop () {
      let imgCrop = this.$refs.vueavatar.getImageScaled()
      let imgURL = imgCrop.toDataURL()
      var uploadFile = new FormData()
      var blob = this.b64toBlob(imgURL)
      uploadFile.append('file', blob, 'file.jpg')
      uploadFile.append('tokenuser', this.tokenbot)
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/setpictureprofileuser', uploadFile).then((response) => {
        if (response.data['status'] === 'success') {
          this.$swal(
            '',
            'เปลี่ยนรูปสำเร็จ.',
            'success'
          )
          this.img = response.data.filename
          this.$refs.vueavatar.loadImage(this.img)
          this.checkUpdateprofile = false
          // this.update_profilebot = { tokenuser: this.tokenbot, picture: this.img, event: 'update_picture' }
          this.$emit('imgUpdate', this.img)
          this.$emit('closeEditdialog', false)
        }
      }, (response) => {
        this.checkUpdateprofile = false
        this.$swal(
          '',
          'ไม่สามารถแก้ไขได้ กรุณาลองใหม่ภายหลัง.',
          'warning'
        )
      })
    }
  }
}
</script>
<style scoped>
>>>.v-card__actions {
  background-color: #f4f4f4;
}
.layoutdialog {
  display: flex;
  justify-content: center;
  background-color: rgb(0, 0, 0);
}
>>>.v-dialog:not(.v-dialog--fullscreen) {
    max-height: 90%;
    width: 40%;
}
</style>
